import React from "react";
import { Col, Row } from "react-bootstrap";

import styled from "styled-components";

export const UnitSpan = styled.span`
  && {
    margin-left: 7px;
  }
`;

export function RowBody({ titleValue, indicesValue, inputValue, unitValue, formulaValue }) {
  return (
    <Row>
      <Title> {titleValue} </Title>
      <Col md={4}>
        <Row className="g-0">
          <Indices>{indicesValue} </Indices>
          <Input>{inputValue} </Input>
          <Unit>{unitValue && <UnitSpan>[{unitValue}]</UnitSpan>}</Unit>
          <Formula>{formulaValue} </Formula>
        </Row>
      </Col>

      <Col md={8}>
        <hr />
      </Col>
    </Row>
  );
}

export function Input(props) {
  return <Col md={5}>{props.children}</Col>;
}

export function Title(props) {
  return <Col md={4}>{props.children}</Col>;
}

export function Indices(props) {
  return (
    <Col md={2}>
      <span>{props.children}</span>
    </Col>
  );
}

export function Formula(props) {
  return (
    <Col md={3}>
      <span>{props.children}</span>
    </Col>
  );
}

export function Unit(props) {
  return <Col md={2}>{props.children}</Col>;
}
